import React from 'react';
import { List, Filter, Datagrid, required,
		TextField,  UrlField, NumberField, 
		DateInput, ReferenceInput, SelectInput } from 'admin-on-rest';
import CHEurField from '../utils/CHEurField';
import { CardActions } from 'material-ui/Card';
import { RefreshButton } from 'admin-on-rest';
import DeleteMonthReportsButton from './DeleteMonthReportsButton';

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const GridActions = ({ resource, filters, displayedFilters, filterValues, basePath, showFilter }) => (
    <CardActions style={cardActionStyle}>
        {filters && React.cloneElement(filters, { resource, showFilter, displayedFilters, filterValues, context: 'button' }) }
        <RefreshButton />       
        <DeleteMonthReportsButton />
    </CardActions>
);

export const MonthGroupedReportList = (props) => (
 	
    <List title="Clicks & omzet per maand" actions={<GridActions />}  perPage={100} {...props}>
        <Datagrid>
            <TextField source="month_disp" sortable={false} />
            <NumberField source="clicks" sortable={false} />
            <CHEurField source="revenue_daisy" label="Daisycon" sortable={false} />
			<CHEurField source="revenue_cloudhints" label="Cloudhints" sortable={false} />
			<CHEurField source="revenue_total" label="Totaal" sortable={false} />			
		</Datagrid>
    </List>
);



// WEBPACK FOOTER //
// ./src/siteclicks/MonthGroupedReportList.js